// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { collection, doc, setDoc  , getDocs , getFirestore , where , query , deleteDoc  , updateDoc , increment  , getDoc  , orderBy , limit} from "firebase/firestore";
import { signInWithEmailAndPassword , getAuth , signOut , updatePassword , sendPasswordResetEmail , fetchSignInMethodsForEmail , onAuthStateChanged } from 'firebase/auth';



// Your web app's Firebase configuration

const firebaseConfig = {
  apiKey: "AIzaSyDSFrPc309fTpKa5bJYLGchWZ8sj72T2CI",
  authDomain: "eltahiq.firebaseapp.com",
  projectId: "eltahiq",
  storageBucket: "eltahiq.appspot.com",
  messagingSenderId: "754104423689",
  appId: "1:754104423689:web:c6a1f5f135dd5669c12fd8",
  measurementId: "G-GN7PDQPLGD"
};
  

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore();
const auth = getAuth();


export { db , setDoc , doc , where , query , collection , getDocs   , deleteDoc , updateDoc , increment , getDoc , signInWithEmailAndPassword , auth , signOut , orderBy ,limit , updatePassword , sendPasswordResetEmail ,fetchSignInMethodsForEmail  , onAuthStateChanged } ;